const AccountsPayable = () => {
  return <div>Cuentas por pagar</div>;
};

export default AccountsPayable;
